var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"ripple-container",on:{"click":_vm.createRipple}},[_vm._t("default",function(){return [_c('button',[_vm._v(_vm._s(_vm.name))])]}),_c('div',{ref:"ripple",staticClass:"ripple",class:{ 'is-active': _vm.isActive },style:(_vm.rippleStyle)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }